<template>
  <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
    <!--        <preLoader v-if="loader"></preLoader>-->
    <div class="container">


      <CCard>
        <CCardHeader>
          <router-link :to="{path: '/order/request/new'}" class="btn btn-success  btn-sm" style="float: right">ثبت
            فاکتور
          </router-link>
          <b-button @click="alertT()" class="btn btn-default  btn-sm mx-2"
                    style="float: right"> Import Excel
          </b-button>
          <b-button data-toggle="modal" data-target="#send-tax" class="btn btn-danger  btn-sm mx-2"
                    style="float: right"> ارسال به سامانه مؤدیان
          </b-button>




          <!--                    <router-link :to="{path: '/loading/list'}" class="btn btn-warning btn-sm  m-1"  style="float: left">ورود و خروج انبار (بارنامه)</router-link>-->

          <!--                    <router-link :to="{path: '/companyPayment/list'}" class="btn btn-info btn-sm  m-1"  style="float: left">پرداختی ها (هزینه)</router-link>-->
          <!--                    <router-link :to="{path: '/customerPayment/list'}" class="btn btn-primary  btn-sm  m-1"  style="float: left">دریافتی ها (درآمد)</router-link>-->


          <button type="button" class="btn btn-default btn-sm m-1" style="float: left"
                  v-on:click="tableToExcel('testTable', 'W3C Example Table')">Export Excel
          </button>

        </CCardHeader>
        <CCardBody>


          <div class="panel panel-default ">
            <div class="panel-heading"><span style="float: left;"> </span>

              <b-row class="mb-3">

                <b-col cols="1" class="pl-0">
<!--                  <b-badge variant="primary" @click="filterData('', '')" class="cursor-pointer">-->
<!--                    نمایش همه-->
<!--                  </b-badge>-->
                </b-col>


                <b-col cols="4" class="pl-0">
                  <!--                                <span>نوع: </span>-->

                  <!--                              <b-badge @click="filterData('-1', 'factor_type')" class="cursor-pointer">-->
                  <!--                                رسید خرید-->
                  <!--                              </b-badge>-->
                  <!--                              <b-badge @click="filterData('2', 'factor_type')" class="cursor-pointer">-->
                  <!--                                حواله تولید-->
                  <!--                              </b-badge>-->
                  <!--                              <b-badge @click="filterData('-2', 'factor_type')" class="cursor-pointer">-->
                  <!--                                رسید تولید-->
                  <!--                              </b-badge>-->
                  <!--                              <b-badge @click="filterData('1', 'factor_type')" class="cursor-pointer">-->
                  <!--                                فاکتور {{ $sale }}-->
                  <!--                              </b-badge>-->
                  <!--                              <b-badge @click="filterData('3', 'factor_type')" class="cursor-pointer">-->
                  <!--                                صورت وضعیت-->
                  <!--                              </b-badge>-->
                </b-col>

                <b-col cols="4" class="px-0">
                  <span>وضعیت: </span>

                  <!--                              <b-badge  variant="dark"  @click="filterData('0', 'state')" class="cursor-pointer">-->
                  <!--                                ثبت اولیه-->
                  <!--                              </b-badge>-->
                  <!--&lt;!&ndash;                              <b-badge  variant="dark" @click="filterData('1', 'state')" class="cursor-pointer">&ndash;&gt;-->
                  <!--&lt;!&ndash;                                برگشتی&ndash;&gt;-->
                  <!--&lt;!&ndash;                              </b-badge>&ndash;&gt;-->
                  <!--                              <b-badge  variant="dark" @click="filterData('2', 'state')" class="cursor-pointer">-->
                  <!--                                پرداخت شده-->
                  <!--                              </b-badge>-->
                  <!--                              <b-badge  variant="dark" @click="filterData('3', 'state')" class="cursor-pointer">-->
                  <!--                                ثبت نهایی-->
                  <!--                              </b-badge>-->
                </b-col>


                <b-col cols="2">
                  <input type="text" v-model="filters.code" @keyup="handleFilterInput"
                         class="form-control input-search form-control-sm"
                         placeholder="شماره فاکتور">
                </b-col>


                <b-col cols="1">
                  <select class="select-search  form-control form-control-sm" v-model="pageSize" @change="handlePageSizeChange">
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col cols="2" class="pl-0">
                  <input v-model="filters.factorId" @keyup="handleFilterInput"
                         class="form-control form-control-sm"
                         placeholder="کد سیستمی">
                </b-col>

                <b-col cols="3">
                  <input v-model="filters.note" @keyup="handleFilterInput"
                         class="form-control form-control-sm"
                         placeholder="شرح">
                </b-col>

                <b-col cols="3">
                  <custom-time-picker v-model="filters.factorDate" :clearable="true"
                                      placeholder="تاریخ فاکتور"
                                      format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                                      @input="applyFilters">
                  </custom-time-picker>
                </b-col>

                <b-col cols="2">
                  <custom-time-picker v-model="filters.createdAt" :clearable="true"
                                      placeholder="تاریخ ایجاد"
                                      format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                                      @input="applyFilters">
                  </custom-time-picker>
                </b-col>

                <b-col cols="2" class="text-left">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">
                    پاک کردن فیلترها
                  </b-button>
                </b-col>
              </b-row>


            </div>
            <div class="panel-body  ">
              <div class="table-responsive">


                <table id="testTable" class="table table-bordered table-striped table-hover">
                  <thead>
                  <tr>
                    <th>
                      <!--                                        {{ $t('Show receipt') }} -->
                    </th>
                    <th>
                      <small> کد سیستمی</small>
                      <!--                                        {{ $t('Show receipt') }} -->
                    </th>
                    <th>
                      <small> شماره فاکتور </small>

                      <!--                                        {{ $t('Show receipt') }} -->
                    </th>

                    <th> خریدار</th>
                    <th class="position"> {{ $t('Date') }}

                      <i v-if="sortKey === 'factorDate' && sortOrder === `DESC`" @click="changeSort(`factorDate`)"
                         class="fa  icon-form">&#xf102;</i>
                      <i v-else @click="changeSort(`factorDate`)"
                         class="fa icon-form">&#xf103;</i>
                    </th>
                    <!--                                    <th class="position">{{ $t('start time') }}-->

                    <!--                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`general_start`,`desc`)"-->
                    <!--                                            class="fa  icon-form">&#xf102;</i>-->
                    <!--                                        <i v-else @click="changeUpDown(`general_start`,`asc`)"-->
                    <!--                                            class="fa icon-form">&#xf103;</i>-->
                    <!--                                    </th>-->
                    <!--                                    <th class="position">{{ $t('End Time') }}-->
                    <!--                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`general_end`,`desc`)"-->
                    <!--                                            class="fa  icon-form">&#xf102;</i>-->
                    <!--                                        <i v-else @click="changeUpDown(`general_end`,`asc`)"-->
                    <!--                                            class="fa icon-form">&#xf103;</i>-->
                    <!--                                    </th>-->
                    <!--                                        <th>{{ $t('Discount') }}</th>-->
                    <th>نوع</th>

                    <th class="position">{{ $t('Final price') }}
                      <i v-if="sortKey === 'payed' && sortOrder === `DESC`" @click="changeSort(`payed`)"
                         class="fa  icon-form">&#xf102;</i>
                      <i v-else @click="changeSort(`payed`)"
                         class="fa icon-form">&#xf103;</i>
                    </th>


                    <!--                                        <th>-->
                    <!--                                            {{ $t('services') }}-->
                    <!--                                        </th>-->
                    <!--                                        <th>{{ $t('Products') }}</th>-->


                    <th>
                      وضعیت
                    </th>


                    <th class="position">تاریخ ایجاد
                      <i v-if="sortKey === 'createdAt' && sortOrder === `DESC`" @click="changeSort(`createdAt`)"
                         class="fa  icon-form">&#xf102;</i>
                      <i v-else @click="changeSort(`createdAt`)"
                         class="fa icon-form">&#xf103;</i>
                    </th>

                    <!--                                        <th>-->
                    <!--                                            شرح-->
                    <!--                                        </th>-->

                    <th>
                      سامانه مودیان
                    </th>
                    <th>
                      ویرایش/حذف
                    </th>

                    <!--                                    <th width="100">&nbsp;</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr id="items" v-for="(item, index) in items" :key="index">
                    <td class="text-center">
                      <router-link :to="{path: '/order/payment/'+item.factorId, params: {id: item.factorId}}">
                        <i class="fa fa-eye"></i>

                        <!--                                                <span v-if="item.factor_type == 2">-->
                        <!--                                    سند خرید-->
                        <!--                                </span>-->

                        <!--                                                <span v-if="item.factor_type == 1">-->
                        <!--                                    فاکتور {{$sale}}-->
                        <!--                                </span>-->
                        <!--                                                <span v-if="item.factor_type == 3">-->
                        <!--                                    صورت وضعیت-->
                        <!--                                </span>-->

                        <!--                                            {{ $t('receipt') }}-->
                      </router-link>
                    </td>
                    <td>
                      <small>{{ item.factorId }}</small>
                    </td>

                    <td>
                      <b>{{ item.code }}</b>

                    </td>


                    <td v-if="item.buyer">
                      <span class="btn btn-xs">{{ item.buyer.note + ' - ' + item.buyer.nationalCode }}</span>
                    </td>
                    <td v-else>
                      {{ $t('Unknown') }}
                    </td>

                    <td>{{ item.factorDate | moment("jYYYY/jMM/jDD") }}</td>
                    <!--                                    <td>{{ item.general_start | moment("jYYYY/jMM/jDD") }}</td>-->
                    <!--                                    <td>{{ item.general_end }}</td>-->
                    <!--                                        <td>{{ spliceNumber(item.general_discount)}}</td>-->
                    <td>


                      <b-badge v-if="item.payType == 'cash' ">
                        نقدی
                      </b-badge>
                      <b-badge v-if="item.payType != 'cash' ">
                        نسیه
                      </b-badge>


                    </td>

                    <td>
                                          <span>
                                             {{ spliceNumber(item.payed) }}
                                          </span>
                    </td>


                    <td><span
                        :class="`badge `+stateColor(item.state)">{{ stateorder(item.state) }}</span>
                    </td>


                    <td>
                      <span>{{ item.createdAt | moment("jYYYY/jMM/jDD") }}</span>
                    </td>

                    <!--                                      <td>-->
                    <!--                                        <small>{{item.note}}</small>-->

                    <!--                                      </td>-->

                    <!--                                    <td>-->
                    <!--                                        &lt;!&ndash; <router-link :to="{name: 'edit-managerOrders', params: {id: item.id}}"-->
                    <!--                                            class="btn btn-xs btn-default">-->
                    <!--                                            ویرایش-->
                    <!--                                        </router-link> &ndash;&gt;-->
                    <!--                                        <span v-if="item.state != 1 && item.state != 3">-->
                    <!--                                            <a href="javascript: void(0)" class="btn btn-xs btn-danger btn-sm"-->
                    <!--                                                v-on:click="deleteEntry(item.id, index)">-->
                    <!--&lt;!&ndash;                                                {{ $t('Cancel') }}&ndash;&gt;-->
                    <!--                                                برگشت / رد فاکتور-->
                    <!--                                            </a></span>-->
                    <!--                                        <span class="" v-else> </span>-->


                    <!--                                    </td>-->

                    <td>
                      <b-button
                          v-on:click="openInquiryModal(item.factorId)"
                          data-toggle="modal"
                          :data-target="'#inquiry'+index"
                          size="sm"
                          variant="success"
                          class="m-1"
                      >
                        استعلام
                      </b-button>
                      <b-button   v-on:click="correction(item.factorId)" data-toggle="modal" data-target="#correction" size="sm" variant="info" class="m-1">
                        اصلاح
                      </b-button>
                      <b-button v-on:click="cancellation(item.factorId)"  data-toggle="modal" data-target="#cancellation" size="sm" variant="secondary"
                                class="m-1">ابطال
                      </b-button>

                    </td>

                    <td>

                      <router-link :to="{path: '/order/edit/'+item.factorId, params: {id: item.factorId}}"
                                    size="sm" variant="outline-warning" class="m-2 btn-sm btn-warning"><i class="fa fa-file"></i>
                    </router-link>

                      <b-button  v-on:click="removeItem(item.factorId, index)"  size="sm" variant="outline-danger" class="m-2"><i class="fa fa-trash"></i></b-button>

                      <!--                                        <small-->
                      <!--                                               v-on:click="removeItem(item.id, index)">-->
                      <!--                                                <i class="fa fa-trash"></i>-->
                      <!--                                            </small>-->

                    </td>
                  </tr>
                  </tbody>
                </table>


              </div>

            </div>
            <div class="col-xs-12 text-center">
              <nav v-if="totalPages > 1" aria-label="Factors pagination">
                <ul class="pagination pagination-sm justify-content-center">
                  <li class="page-item" :class="{ disabled: currentPage === 0 }">
                    <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage === 0">
                      قبلی
                    </button>
                  </li>
                  <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: currentPage === page - 1 }">
                    <button type="button" class="page-link" @click="goToPage(page - 1)">
                      {{ page }}
                    </button>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= totalPages - 1 }">
                    <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= totalPages - 1">
                      بعدی
                    </button>
                  </li>
                </ul>
              </nav>
              <small class="text-muted d-block mb-2">{{ totalElements }} رکورد</small>
            </div>
          </div>


          <!-- Modal -->
          <div :id="'send-tax'" class="modal modal-lg fade" role="dialog">
            <div class="modal-dialog">

              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                  <h4 class="modal-title"> ارسال به سامانه مودیان </h4>
                </div>


                <div class="modal-body">
                  <div style="margin:5px">


                    <div class="col-xs-12 form-group">
                      <label class="control-label">
                        شناسه یکتای شرکت
                      </label>
                      <input v-model="auth.headers.UniqueCode" type="text" class="form-control">
                      <br>
                    </div>


                    <label class="control-label"> ارسال براساس
                    </label>
                    <b-form-select v-model="sendTax.basedOn" @change="resetSendTaxObj()" class="mb-4 ">
                      <b-form-select-option value="factor_code">
                        شماره فاکتور
                      </b-form-select-option>
                      <b-form-select-option value="factor_date">
                        تاریخ فاکتور
                      </b-form-select-option>
                      <b-form-select-option value="factor_id">
                        کد سیستمی فاکتور
                      </b-form-select-option>
                    </b-form-select>


                    <div v-if="sendTax.basedOn === 'factor_code'" class="col-xs-12 form-group">
                      <label class="control-label">
                        از شماره فاکتور
                      </label>
                      <input v-model="sendTax.codeFrom" type="text" class="form-control">
                      <br>
                      <label class="control-label">
                        تا شماره فاکتور
                      </label>
                      <input v-model="sendTax.codeTo" type="text" class="form-control">
                      <br>
                    </div>


                    <div v-if="sendTax.basedOn === 'factor_date'" class="col-xs-12 form-group">

                      <label class="control-label">
                        از تاریخ
                      </label>
                      <custom-time-picker v-model="sendTax.fromDate" :clearable="true"
                                          placeholder="تاریخ را انتخاب کنید"
                                          format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" min="" max="">
                      </custom-time-picker>
                      <br>
                      <label class="control-label">
                        تا تاریخ
                      </label>
                      <custom-time-picker v-model="sendTax.toDate" :clearable="true"
                                          placeholder="تاریخ را انتخاب کنید"
                                          format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" min="" max="">
                      </custom-time-picker>
                      <br>

                    </div>

                    <div v-if="sendTax.basedOn === 'factor_id'" class="col-xs-12 form-group">

                      <label class="control-label">
                        کد سیستمی فاکتور
                      </label>
                      <input v-model="sendTax.factorId" type="text" class="form-control">
                      <br>


                    </div>


                  </div>
                  <br>

                  <button v-on:click="sendTaxApi()" data-dismiss="modal"
                          class="btn btn-success mx-1">
                    ارسال به سامانه مودیان
                  </button>

                  <button type="button" class="btn btn-default mx-1" data-dismiss="modal">انصراف</button>
                </div>
              </div>
              <!-- <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

              </div> -->
            </div>


          </div>


          <!-- Modal -->
          <div :id="'inquiry'+indexRef" v-for="(itemRef, indexRef) in items" :key="indexRef" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered inquiry-modal-dialog">

              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                  <h4 class="modal-title"> استعلام وضعیت ارسال فاکتور </h4>
                </div>


                <div class="modal-body">

                  <div class="inquiry-factor-meta mb-3">
                    <div class="inquiry-meta-item">
                      <small class="text-muted">شماره فاکتور:</small>
                      <b>{{ itemRef.code || '-' }}</b>
                    </div>
                    <div class="inquiry-meta-item">
                      <small class="text-muted">تاریخ فاکتور:</small>
                      <b>{{ itemRef.factorDate | moment("jYYYY/jMM/jDD") }}</b>
                    </div>
                    <div class="inquiry-meta-item">
                      <small class="text-muted">تاریخ ایجاد:</small>
                      <b>{{ itemRef.createdAt | moment("jYYYY/jMM/jDD") }}</b>
                    </div>
                  </div>

                  <div class="col-xs-12 form-group">


                    <table id="ref" class="table table-bordered table-striped table-hover">
                      <thead>
                      <tr>

                        <th>ارسال موفق</th>
                        <th>
                          <small>رفرنس</small>
                        </th>
                        <th>

                        </th>
                        <th>نتیجه استعلام</th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr id="refs" v-for="(reference, indexReference) in factorReferences" :key="indexReference">

                        <td> {{reference.successesAt}}</td>
                        <td>
                          <small class="details-text">
                            {{ reference.taxApiReference || reference.taxApiSuccessesReference || '-' }}
                          </small>
                        </td>

                        <td>

                          <b-button
                              v-on:click="inquiryFactor(reference.taxApiUid, indexReference)"
                              :disabled="reference.inquiryLoading"
                              size="sm"
                              variant="outline-danger"
                              class="m-2"
                          >
                            <span v-if="reference.inquiryLoading">در حال استعلام...</span>
                            <span v-else>استعلام وضعیت</span>
                          </b-button>

                        </td>

                        <td>
                          <div class="inquiry-result">
                            <p v-if="reference.inquiryLoading" class="mb-2 text-primary">
                              <b>در حال دریافت وضعیت...</b>
                            </p>

                            <p v-if="reference.inquiryErrorMessage" class="mb-2">
                              <b class="text-danger">{{ reference.inquiryErrorMessage }}</b>
                            </p>

                            <div v-if="getInquiryEntries(reference).length">
                              <div
                                  v-for="(inquiryData, inquiryIndex) in getInquiryEntries(reference)"
                                  :key="'inquiry-'+indexReference+'-'+inquiryIndex"
                                  class="inquiry-entry"
                              >
                                <p v-if="inquiryData.status" class="mb-2">
                                  <span :class="inquiryStatusClassByStatus(inquiryData.status)">
                                    {{ inquiryStatusLabelByStatus(inquiryData.status) }}
                                  </span>
                                </p>

                                <div v-if="inquiryData.data">
                                  <div v-if="getInquiryEntryErrors(inquiryData).length" class="mb-2">
                                    <p
                                        v-for="(errorData, errorIndex) in getInquiryEntryErrors(inquiryData)"
                                        :key="'error-'+indexReference+'-'+inquiryIndex+'-'+errorIndex"
                                        class="mb-1"
                                    >
                                      <small>{{ errorData.code || 'ERROR' }} - </small>
                                      <b class="text-danger">{{ errorData.message || errorData }}</b>
                                    </p>
                                  </div>

                                  <div v-if="getInquiryEntryWarnings(inquiryData).length" class="mb-2">
                                    <p
                                        v-for="(warningData, warningIndex) in getInquiryEntryWarnings(inquiryData)"
                                        :key="'warning-'+indexReference+'-'+inquiryIndex+'-'+warningIndex"
                                        class="mb-1"
                                    >
                                      <small>{{ warningData.code || 'WARNING' }} - </small>
                                      <b class="text-warning">{{ warningData.message || warningData }}</b>
                                    </p>
                                  </div>
                                </div>

                                <p v-if="inquiryData.referenceNumber" class="mb-1">
                                  <small class="text-muted">رفرنس:</small>
                                  <span class="details-text">{{ inquiryData.referenceNumber }}</span>
                                </p>

                                <p v-if="inquiryData.uid" class="mb-1">
                                  <small class="text-muted">UID:</small>
                                  <span class="details-text">{{ inquiryData.uid }}</span>
                                </p>
                              </div>
                            </div>
                            <div v-else>
                              <p class="mb-1">
                                <span :class="inquiryStatusClass(reference, reference.taxApiState)">
                                  {{ inquiryStatusLabel(reference, reference.taxApiState) }}
                                </span>
                              </p>
                              <p v-if="reference.taxApiMessage && typeof reference.taxApiMessage === 'string'" class="mb-0">
                                <b class="text-danger">{{ reference.taxApiMessage }}</b>
                              </p>
                            </div>
                          </div>

                        </td>
                      </tr>
                      </tbody>
                    </table>




                  </div>



                  <button type="button" class="btn btn-default" data-dismiss="modal">بستن</button>
                </div>
              </div>
              <!-- <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

              </div> -->
            </div>


          </div>


        </CCardBody>
      </CCard>


    </div>
  </div>
</template>


<script>
const auth = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token')
  }
};

export default {

  data: function () {
    return {
      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
          UniqueCode: ''
        }
      },
      roles: JSON.parse(localStorage.getItem('roles')),
      items: [],
      pagnationDate: [],
      pageNumber: [],
      current_page: '',
      loader: false,
      search: "",
      length: "",
      orderIcon: "",
      pageSize: 25,
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,
      sortKey: 'createdAt',
      sortOrder: 'DESC',
      filters: {
        code: '',
        factorId: '',
        note: '',
        factorDate: '',
        createdAt: ''
      },
      filterTimeout: null,

      sendTax: {
        basedOn: 'factor_code',
        codeFrom: '',
        codeTo: '',
        fromDate: '',
        toDate: '',
        factorId: ''
      },

      inquiry: {
        uid: '',
        reference: ''
      },
      factorReferences:[],



    }
  },


  mounted() {

    // this.$store.state.roles = this.pluck(JSON.parse(localStorage.getItem('roles')), 'name')
    // this.$store.state.accesses = ['superadministrator', 'admin']
    // this.$store.commit('intersection')
    // this.$store.commit('checkIntersection')

    this.fetchFactors()

    // //     this.pageNumbers(`api/orders`)
    // //    this.pagnation( `api/orders`)
    // //  this.activeclass(0)
  },
  methods: {
    buildFactorParams(page = this.currentPage) {
      const params = {
        companyId: this.$companyId,
        page,
        pageSize: Number(this.pageSize),
        sortKey: this.sortKey,
        sortOrder: this.sortOrder
      }

      if (this.filters.code) {
        params.codeFrom = this.filters.code
        params.codeTo = this.filters.code
      }
      if (this.filters.factorId) {
        params.factorId = this.filters.factorId
      }
      if (this.filters.note) {
        params.note = this.filters.note
      }
      if (this.filters.factorDate) {
        params.factorDate = this.formatDateTimeFilter(this.filters.factorDate)
      }
      if (this.filters.createdAt) {
        params.createdAt = this.formatDateTimeFilter(this.filters.createdAt)
      }

      return params
    },
    formatDateTimeFilter(value) {
      if (!value) {
        return ''
      }

      const date = new Date(`${value}T00:00:00`)
      if (Number.isNaN(date.getTime())) {
        return value
      }

      return date.toISOString().replace('Z', '+00:00')
    },
    fetchFactors(page = this.currentPage) {
      this.loader = true
      axios.get('v2/api/factor-service/factors/getFactorsPaginated/byFilter', {
        ...this.auth,
        params: this.buildFactorParams(page)
      })
          .then(response => {
            const data = response.data || {}
            this.items = data.content || []
            this.currentPage = data.number || 0
            this.current_page = (data.number || 0) + 1
            this.totalPages = data.totalPages || 0
            this.totalElements = data.totalElements || 0
            this.pageSize = data.size || this.pageSize
          })
          .catch(e => {
            this.authCheck(e)
          })
          .finally(() => {
            this.loader = false
          })
    },
    stateColor(index) {
      switch (index) {

        case '0':
          return "badge-info"
          break;
        case '1':
          return 'badge-danger'
          break;
        case '2':
          return 'badge-success'
          break;
        case '3':
          return "badge-primary"
          break;
        default:
          break;
      }
    },
    stateorder(index) {
      switch (index) {

        case '0':
          return 'ثبت اولیه'
          break;
        case '1':
          return 'برگشت خورده'
          break;
        case '2':
          return 'پرداخت شده'
          break;
        case '3':
          return 'ثبت نهایی سند'
          break;
        default:
          break;
      }
    },
    changeUpDown(column, orderBY) {
      if (column) {
        this.sortKey = column
      }
      if (orderBY) {
        this.sortOrder = orderBY.toUpperCase()
      }
      this.orderIcon = this.sortOrder.toLowerCase()
      this.fetchFactors(0)
    },
    changeSort(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'DESC' ? 'ASC' : 'DESC'
      } else {
        this.sortKey = column
        this.sortOrder = 'DESC'
      }
      this.orderIcon = this.sortOrder.toLowerCase()
      this.fetchFactors(0)
    },
    handleFilterInput() {
      clearTimeout(this.filterTimeout)
      this.filterTimeout = setTimeout(() => {
        this.applyFilters()
      }, 400)
    },
    applyFilters() {
      this.fetchFactors(0)
    },
    handlePageSizeChange() {
      this.fetchFactors(0)
    },
    goToPage(page) {
      if (page < 0 || page >= this.totalPages || page === this.currentPage) {
        return
      }
      this.fetchFactors(page)
    },
    resetFilters() {
      this.filters = {
        code: '',
        factorId: '',
        note: '',
        factorDate: '',
        createdAt: ''
      }
      this.fetchFactors(0)
    },


    filterData(search, field = '', column = '', orderBY = 'desc') {
      if (search !== undefined && search !== null && search !== '') {
        this.filters.code = search
      }
      if (column) {
        this.sortKey = column
      }
      if (orderBY) {
        this.sortOrder = orderBY.toUpperCase()
      }
      this.fetchFactors(0)
    },

    deleteEntry(id, index) {
      if (confirm(this.$t('Are you sure you want to cancel the order?'))) {

        var newItem = {
          order_id: id,
        };
        var app = this;
        axios.post('/api/orders/cancel', newItem, app.auth)

            .then(function (resp) {

              app.$snotify.success(app.$t('Cancellation successful'));


              //////////////// It had to be changed latter //////////////////////

              axios.get('api/orders', app.auth)
                  .then(response => {
                    app.items = response.data.data;
                  })
                  .catch(error => {
                    console.log(error);
                  })


            })
            .catch(function (resp) {
              app.$snotify.warning(app.$t('Cannot cancel item'));

            });

      }
    },


    removeItem(id, index) {

      if (confirm("از حذف سند مطمئن هستید؟")) {
        var app = this;
        axios.delete('/v2/api/factor-service/factors?factorId='+id
            , app.auth)
            .then(function (resp) {
              if (app.items.length === 1 && app.currentPage > 0) {
                app.fetchFactors(app.currentPage - 1);
                return;
              }
              app.fetchFactors(app.currentPage);
            })
            .catch(function (resp) {
              //                            alert("امکان حذف آیتم وجود ندارد");
              app.$snotify.error("امکان حذف آیتم وجود ندارد");
            });
      }
    },


    getRelation(id) {
      axios.get('api/orders/' + id, this.auth)
          .then(function (resp) {
            console.log(resp.data.data.id);
            return resp.data.data.id;
          })
          .catch(function (resp) {
            return this.$t('Unknown');
          });
    },

    pagnation(api) {
      this.fetchFactors(this.currentPage)
    },


    spliceNumber(number) {
      //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

      $("input[data-type='number']").keyup(function (event) {
        var $this = $(this);
        var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
        $this.val(num2);
      });
      if (number !== null) {
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      }

    },


    tableToExcel(table, name) {

      var uri = 'data:application/vnd.ms-excel;base64,',
          template =
              '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
          base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)))
          },
          format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
              return c[p];
            })
          }


      if (!table.nodeType) table = document.getElementById(table)
      var ctx = {
        worksheet: name || 'Worksheet',
        table: table.innerHTML
      }
      window.location.href = uri + base64(format(template, ctx))

    },

    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },

    alertT() {
      this.$snotify.warning('عدم دسترسی')
    },


    sendTaxApi() {
      let app = this
      // app.auth.headers.UniqueCode = 'AAAAAA'
      axios.post(`v2/api/tax-service/invoice/send-invoice?basedOn=${this.sendTax.basedOn}&codeFrom=${this.sendTax.codeFrom}&codeTo=${this.sendTax.codeTo}&fromDate=${this.sendTax.fromDate}&toDate=${this.sendTax.toDate}&factorId=${this.sendTax.factorId}&companyId=${this.$companyId}`,
          null, app.auth)
          .then(function (resp) {
            app.$snotify.info('ارسال انجام شد');


          })
          .catch(function (e) {
            this.authCheck(e)
          });

    },



    getReferences(factorId) {

      let app = this

      app.factorReferences = []
      axios.get(`v2/api/tax-service/inquiry/get-references?factorId=${factorId}&companyId=${app.$companyId}`,
           app.auth)
          .then(function (resp) {

            app.factorReferences = (resp.data || []).map(function (reference) {
              return {
                ...reference,
                inquiryLoading: false,
                inquiryErrorMessage: ''
              }
            });/////////


          })
          .catch(function (e) {
            app.authCheck(e)
          });

    },
    openInquiryModal(factorId) {
      this.getReferences(factorId)
    },


    inquiryFactor(uid,index) {
      let app = this
      if (!app.factorReferences[index]) {
        return
      }

      app.factorReferences[index].inquiryLoading = true
      app.factorReferences[index].inquiryErrorMessage = ''

      axios.get(`v2/api/tax-service/inquiry/get-by-uid?uid=${uid}&companyId=${this.$companyId}`,
           app.auth)
          .then(function (resp) {
            ///////////////// need to consider : add find by uid and update data in list

            app.factorReferences[index].taxApiMessage = resp.data;
            app.factorReferences[index].inquiryLoading = false
          })
          .catch(function (e) {
            app.factorReferences[index].inquiryLoading = false
            app.factorReferences[index].inquiryErrorMessage = app.getInquiryErrorMessage(e)
          });

    },
    getInquiryErrorMessage(error) {
      const defaultMessage = 'بروز خطا در استعلام وضعیت'
      const responseData = error && error.response ? error.response.data : null
      const responseMessage = responseData && responseData.message ? responseData.message : ''
      const rawMessage = responseMessage || (error && error.message ? error.message : '')

      if (rawMessage.indexOf('Invalid AES key length: 26 bytes') !== -1) {
        return 'شناسه یکتای شرکت را در قسمت ارسال به سامانه مودیان به درستی وارد کند و مجدد استعلام بگیرید'
      }

      return rawMessage || defaultMessage
    },
    normalizeInquiryPayload(reference) {
      if (!reference) {
        return {}
      }

      const payload = reference.taxApiMessage

      if (!payload) {
        return {}
      }

      if (typeof payload === 'string') {
        try {
          return JSON.parse(payload)
        } catch (e) {
          return {
            message: payload
          }
        }
      }

      return payload
    },
    parseInquiryInnerDataModelString(value) {
      if (!value || typeof value !== 'string' || value.indexOf('InquiryInnerDataModel(') === -1) {
        return null
      }

      const parseObjects = (sectionText) => {
        if (!sectionText || sectionText === 'null') {
          return []
        }

        return sectionText
            .split(/,\s*ErrorObject\(/)
            .map((item, index) => {
              const normalizedItem = index === 0 ? item : `ErrorObject(${item}`
              const codeMarker = 'code='
              const messageMarker = ', message='
              const codeStart = normalizedItem.indexOf(codeMarker)
              const messageStart = normalizedItem.indexOf(messageMarker)

              if (codeStart === -1 || messageStart === -1) {
                return null
              }

              const code = normalizedItem
                  .slice(codeStart + codeMarker.length, messageStart)
                  .trim()

              const rawMessage = normalizedItem
                  .slice(messageStart + messageMarker.length)
                  .trim()

              const message = rawMessage.endsWith(')')
                  ? rawMessage.slice(0, -1).trim()
                  : rawMessage

              return {
                code,
                message
              }
            })
            .filter(Boolean)
      }

      const errorMatch = value.match(/error=\[(.*?)\](?:, warning=|,warning=|\))/)
      const warningMatch = value.match(/warning=\[(.*?)\]\)?$/)

      return {
        error: parseObjects(errorMatch ? errorMatch[1] : ''),
        warning: parseObjects(warningMatch ? warningMatch[1] : '')
      }
    },
    getInquiryEntries(reference) {
      const payload = this.normalizeInquiryPayload(reference)

      if (Array.isArray(payload)) {
        return payload
      }

      if (payload && Array.isArray(payload.data)) {
        return payload.data
      }

      if (payload && payload.status) {
        return [payload]
      }

      return []
    },
    getInquiryEntryErrors(inquiryData) {
      if (!inquiryData) {
        return []
      }

      const parsedStringData = this.parseInquiryInnerDataModelString(inquiryData.data)
      if (parsedStringData && parsedStringData.error.length) {
        return parsedStringData.error
      }

      const data = inquiryData.data || {}
      return this.normalizeInquiryList(data.error)
    },
    getInquiryEntryWarnings(inquiryData) {
      if (!inquiryData) {
        return []
      }

      const parsedStringData = this.parseInquiryInnerDataModelString(inquiryData.data)
      if (parsedStringData && parsedStringData.warning.length) {
        return parsedStringData.warning
      }

      const data = inquiryData.data || {}
      return this.normalizeInquiryList(data.warning)
    },
    normalizeInquiryStatus(status) {
      if (!status) {
        return ''
      }

      const normalized = String(status).toUpperCase()

      if (['SUCCESS', 'SUCCEEDED', 'DONE', 'OK'].includes(normalized)) {
        return 'SUCCESS'
      }

      if (['FAILED', 'FAIL', 'ERROR', 'REJECTED'].includes(normalized)) {
        return 'FAILED'
      }

      if (['IN_PROGRESS', 'PENDING', 'PROCESSING', 'SENT'].includes(normalized)) {
        return 'IN_PROGRESS'
      }

      return normalized
    },
    resolveInquiryStatus(reference, fallbackStatus = '') {
      const payload = this.normalizeInquiryPayload(reference)
      return this.normalizeInquiryStatus(
          payload.status ||
          payload.taxApiState ||
          payload.state ||
          fallbackStatus
      )
    },
    hasInquiryStatus(reference) {
      return !!this.resolveInquiryStatus(reference)
    },
    inquiryStatusClass(reference, fallbackStatus = '') {
      const status = this.resolveInquiryStatus(reference, fallbackStatus)
      return this.inquiryStatusClassByStatus(status)
    },
    inquiryStatusClassByStatus(status) {
      const normalizedStatus = this.normalizeInquiryStatus(status)

      if (normalizedStatus === 'SUCCESS') {
        return 'badge badge-success inquiry-badge'
      }

      if (normalizedStatus === 'FAILED') {
        return 'badge badge-danger inquiry-badge'
      }

      if (normalizedStatus === 'IN_PROGRESS') {
        return 'badge badge-primary inquiry-badge'
      }

      return 'badge badge-secondary inquiry-badge'
    },
    inquiryStatusLabel(reference, fallbackStatus = '') {
      const status = this.resolveInquiryStatus(reference, fallbackStatus)
      return this.inquiryStatusLabelByStatus(status || fallbackStatus)
    },
    inquiryStatusLabelByStatus(status) {
      const normalizedStatus = this.normalizeInquiryStatus(status)

      if (normalizedStatus === 'SUCCESS') {
        return 'ارسال موفق'
      }

      if (normalizedStatus === 'FAILED') {
        return 'ارسال ناموفق'
      }

      if (normalizedStatus === 'IN_PROGRESS') {
        return 'در جریان ارسال'
      }

      if (status) {
        return status
      }

      return 'نامشخص'
    },
    normalizeInquiryList(value) {
      if (!value) {
        return []
      }

      if (Array.isArray(value)) {
        return value
      }

      return [value]
    },
    getInquiryErrors(reference) {
      const payload = this.normalizeInquiryPayload(reference)
      const payloadData = payload.data || {}
      const parsedStringData = this.parseInquiryInnerDataModelString(payloadData)

      if (parsedStringData && parsedStringData.error.length) {
        return parsedStringData.error
      }

      return this.normalizeInquiryList(
          payloadData.error ||
          payload.error ||
          payload.errors
      )
    },
    getInquiryWarnings(reference) {
      const payload = this.normalizeInquiryPayload(reference)
      const payloadData = payload.data || {}
      const parsedStringData = this.parseInquiryInnerDataModelString(payloadData)

      if (parsedStringData && parsedStringData.warning.length) {
        return parsedStringData.warning
      }

      return this.normalizeInquiryList(
          payloadData.warning ||
          payload.warning ||
          payload.warnings
      )
    },
    getInquiryMessageText(reference) {
      const payload = this.normalizeInquiryPayload(reference)

      if (payload.message && typeof payload.message === 'string') {
        return payload.message
      }

      if (payload.taxApiMessage && typeof payload.taxApiMessage === 'string') {
        return payload.taxApiMessage
      }

      if (reference.taxApiMessage && typeof reference.taxApiMessage === 'string') {
        return reference.taxApiMessage
      }

      return ''
    },



    invoiceCorrection(factorId) {
      let app = this
      axios.get(`v2/api/tax-service/inquiry/invoice-correction?factorId=${factorId}&companyId=${this.$companyId}`,
          app.auth)
          .then(function (resp) {
            app.$snotify.info(' درخواست اصلاح ارسال شد');

          })
          .catch(function (e) {
            this.authCheck(e)
          });

    },

    invoiceCancellation(factorId) {
      let app = this
      axios.get(`v2/api/tax-service/inquiry/invoice-cancellation?factorId=${factorId}&companyId=${this.$companyId}`,
          app.auth)
          .then(function (resp) {
            app.$snotify.info(' درخواست ابطال ارسال شد');

          })
          .catch(function (e) {
            this.authCheck(e)
          });

    },


    authCheck(e) {
      let app = this
      const qs = require('qs');
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      if (e.response.status === 401) {
        let userData = {
          grant_type: "refresh_token",
          client_id: "cyan-business",
          client_secret: "v4lyYR70VzyDtcKwYm7hKw9O4HB2jtoK",
          refresh_token: localStorage.getItem('refresh_token'),
        }
        axios.post('realms/cyan/protocol/openid-connect/token', qs.stringify(userData), config)
            .then(function (response) {
              localStorage.setItem('token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              app.$snotify.warning("مجدد تلاش کنید");
            })
            .catch(function (e) {
              console.log(e.response);
              // if (e.response.status === 400)
                app.logout();
              app.$snotify.warn("مجدد وارد شوید");

            });
      } else {
        app.$snotify.error("بروز خطا");
        app.$snotify.warning(e.response.data.message);

      }
    },


    resetSendTaxObj() {
          this.sendTax.codeFrom = '',
          this.sendTax.codeTo = '',
          this.sendTax.fromDate = '',
          this.sendTax.toDate = '',
          this.sendTax.factorId = ''
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('name');
      localStorage.removeItem('family');
      localStorage.removeItem('email');
      localStorage.removeItem('state');
      localStorage.removeItem('role');
      localStorage.removeItem('roles');
      // axios.get('/api/auth/logout', this.auth);
      this.$router.push({
        path: '/login'
      });

    },




    correction(id) {

      if (confirm("از اصلاح سند مطمئن هستید؟")) {
        var app = this;
        axios.post('/v2/api/tax-service/invoice/invoice-correction?companyId='+this.$companyId+'&factorId=' + id ,null,
            app.auth)
            .then(function (resp) {
              app.$snotify.success("ارسال درخواست انجام شد");

            })
            .catch(function (resp) {
              //                            alert("امکان حذف آیتم وجود ندارد");
              app.$snotify.error("امکان ارسال اصلاح آیتم وجود ندارد");
            });
      }
    },

    cancellation(id) {

      if (confirm("از ابطال سند مطمئن هستید؟")) {
        var app = this;
        axios.post('/v2/api/tax-service/invoice/invoice-cancellation?companyId='+this.$companyId+'&factorId=' + id ,null,
            app.auth)
            .then(function (resp) {
              app.$snotify.success("ارسال درخواست انجام شد");
            })
            .catch(function (resp) {
              //                            alert("امکان حذف آیتم وجود ندارد");
              app.$snotify.error("امکان ارسال ابطال آیتم وجود ندارد");
            });
      }
    }
  },
  computed: {
    visiblePages() {
      const total = this.totalPages
      if (!total) {
        return []
      }

      const current = this.currentPage + 1
      const start = Math.max(1, current - 2)
      const end = Math.min(total, start + 4)
      const first = Math.max(1, end - 4)
      const pages = []

      for (let page = first; page <= end; page += 1) {
        pages.push(page)
      }

      return pages
    }
  }
}

</script>
<style scoped>
/* .label-info {
color: #fff;
background-color: #17a2b8;
}


.label-warning {
color: #212529;
background-color: #ffc107;
}

.label-danger {
color: #fff;
background-color: #dc3545;
}
.label-success {
color: #fff;
background-color: greenyellow;
}
.label-gray {
color: #fff;
background-color:gray;
} */


/* Tooltip container */
.tooltipmain {
  position: relative;
  display: inline-block;
  /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltipmain .tooltiptextmain {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltipmain .tooltiptextmain::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltipmain:hover .tooltiptextmain {
  visibility: visible;
  opacity: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.reference-summary {
  line-height: 1.8;
}

.inquiry-modal-dialog {
  max-width: 860px;
  width: calc(100% - 32px);
  margin: 1.75rem auto;
}

.inquiry-result {
  line-height: 1.8;
}

.inquiry-entry {
  padding: 10px 0;
  border-bottom: 1px solid #ececec;
}

.inquiry-entry:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.inquiry-factor-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.inquiry-meta-item {
  line-height: 1.8;
}

.inquiry-badge {
  font-weight: 700;
}

.details-text {
  word-break: break-word;
}

</style>
